import { render, staticRenderFns } from "./SavedSearchRow.vue?vue&type=template&id=023eacc8&scoped=true"
import script from "./SavedSearchRow.vue?vue&type=script&lang=js"
export * from "./SavedSearchRow.vue?vue&type=script&lang=js"
import style0 from "./SavedSearchRow.vue?vue&type=style&index=0&id=023eacc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023eacc8",
  null
  
)

export default component.exports